import { css } from 'linaria';

export const dynamicPageRendererStyle = css`
  width: 100%;
`;
